import { useMutation, useQueryClient } from '@tanstack/react-query';
import { auth } from '../config/firebase';

export const useBrandDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (brandId: string) => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch(`https://api.socialness.ai/management/brands/${brandId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to delete brand');
      }

      return response.json();
    },
    onSuccess: () => {
      // Invalidate and refetch brands query
      queryClient.invalidateQueries({ queryKey: ['brands'] });
    }
  });
};